// Split out of InstanceDetailPage.tsx.

import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { LinkButton } from '../../components/ui'

export function extractApiError(e: unknown): string | undefined {
  return (e as { response?: { data?: { error?: string } } })?.response?.data?.error
}

// Parse status_message strings like "installing_template_module_3_of_7" into a
// user-facing i18n string. Falls back to the raw key if no match.
export function useStatusMessageText() {
  const { t } = useTranslation()
  return (msg: string | undefined) => {
    if (!msg) return ''
    const m = msg.match(/^installing_template_module_(\d+)_of_(\d+)$/)
    if (m) {
      return t('detail.installingTemplateModule', { current: Number(m[1]), total: Number(m[2]) })
    }
    const d = msg.match(/^downloading_template_module_(\d+)_of_(\d+)$/)
    if (d) {
      return t('detail.downloadingTemplateModule', { current: Number(d[1]), total: Number(d[2]) })
    }
    const b = msg.match(/^installing_template_modules_(\d+)$/)
    if (b) {
      return t('detail.installingTemplateModules', { count: Number(b[1]) })
    }
    return t(`status.msg.${msg}`, msg)
  }
}

/**
 * Imported by tabs outside this migration (DangerTab). Props and behaviour are
 * unchanged — the hand-written classes it carried
 * (`text-xs text-brand-600 hover:text-brand-700 font-medium`) are byte-for-byte
 * `LinkButton tone="accent"`, so this is the primitive swap with no visual diff.
 */
export function CopyButton({ text }: { text: string }) {
  const [copied, setCopied] = useState(false)
  const { t } = useTranslation()
  return (
    <LinkButton
      tone="accent"
      onClick={() => { navigator.clipboard.writeText(text); setCopied(true); setTimeout(() => setCopied(false), 1500) }}
    >
      {copied ? t('detail.overview.copied') : t('detail.overview.copy')}
    </LinkButton>
  )
}
